import React, { useState, useEffect } from "react";
import axios from "axios";
import "./DomainListing.css";
import Header from "../../components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

const DomainListing = () => {
    const [domains, setDomains] = useState([]);
    const [tlds, setTlds] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(52);
    const [pages, setPages] = useState(0);
    const [loading, setLoading] = useState(true);
    
    // Temporary filters (before applying)
    const [tempSearch, setTempSearch] = useState("");
    const [tempTld, setTempTld] = useState("");
    const [tempPriceFilter, setTempPriceFilter] = useState("");
    
    // Applied filters
    const [appliedFilters, setAppliedFilters] = useState({
        search: "",
        tld: "",
        maxPrice: "", // Changed from minPrice to maxPrice
    });

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    // Fetch TLDs
    useEffect(() => {
        const fetchTlds = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/all-tlds`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                setTlds(response.data.data);
            } catch (error) {
                console.error("Error fetching TLDs:", error);
            }
        };
        fetchTlds();
    }, []);

    // Fetch domains with applied filters
    useEffect(() => {
        const fetchDomains = async () => {
            try {
                setLoading(true);
                console.log("Fetching with filters:", {
                    search: appliedFilters.search,
                    tld: appliedFilters.tld,
                    maxPrice: appliedFilters.maxPrice,
                    page,
                    limit
                });
                
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/userDomainsList`, {
                    params: {
                        search: appliedFilters.search,
                        tld: appliedFilters.tld,
                        maxPrice: appliedFilters.maxPrice,
                        page,
                        limit
                    },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                
                console.log("API Response:", response.data);
                setDomains(response.data.data);
                setPages(response.data.pages);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching domains:", error);
                setLoading(false);
            }
        };
        fetchDomains();
    }, [appliedFilters, page, limit]);

    // Handle Apply Filters
    const handleApplyFilters = () => {
        let maxPrice = "";
        
        // Set maximum price based on selection
        if (tempPriceFilter === "0-100") {
            maxPrice = "100"; // Show domains with price <= 100
        } else if (tempPriceFilter === "101-500") {
            maxPrice = "500"; // Show domains with price <= 500
        } else if (tempPriceFilter === "501-999") {
            maxPrice = "999"; // Show domains with price <= 999
        }
        
        setAppliedFilters({
            search: tempSearch,
            tld: tempTld,
            maxPrice: maxPrice
        });
        setPage(1);
    };

    // Handle Remove Filters
    const handleRemoveFilters = () => {
        setTempSearch("");
        setTempTld("");
        setTempPriceFilter("");
        setLimit(52);
        setAppliedFilters({
            search: "",
            tld: "",
            maxPrice: ""
        });
        setPage(1);
    };

    return (
        <>
            <Header />
            <div className="domain-listing-container">
                <div className="filters-section">
                    <div className="filters-header">
                        <h3 className="filter-title">Complete Premium Domain listings</h3>
                        <h3 className="filter-title2">Use filter to narrow down your desired domain search click apply button to began</h3>
                    </div>

                    <div className="filter-controls">
                        <div className="filter-group">
                            <label className="filter-label">Search by name</label>
                            <input
                                type="text"
                                className="filter-input"
                                placeholder="Start typing..."
                                value={tempSearch}
                                onChange={(e) => setTempSearch(e.target.value)}
                            />
                        </div>

                        <div className="filter-group">
                            <label className="filter-label">Domain ending (TLD)</label>
                            <select
                                className="filter-input filter-select"
                                value={tempTld}
                                onChange={(e) => setTempTld(e.target.value)}
                            >
                                <option value="">All TLDs</option>
                                {tlds.map((tldOption) => (
                                    <option key={tldOption} value={tldOption}>
                                        .{tldOption}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="filter-group">
                            <label className="filter-label">Maximum Price</label>
                            <select
                                className="filter-input filter-select"
                                value={tempPriceFilter}
                                onChange={(e) => setTempPriceFilter(e.target.value)}
                            >
                                <option value="">All prices</option>
                                <option value="0-100">💰 Up to $100</option>
                                <option value="101-500">💰 Up to $500</option>
                                <option value="501-999">💰 Up to $999</option>
                            </select>
                        </div>

                        <div className="filter-group">
                            <label className="filter-label">Items per page</label>
                            <select
                                className="filter-input filter-select"
                                value={limit}
                                onChange={(e) => setLimit(Number(e.target.value))}
                            >
                                <option value={50}>50 domains</option>
                                <option value={75}>75 domains</option>
                                <option value={100}>100 domains</option>
                            </select>
                        </div>
                    </div>
                    <div className="filter-actions">
                        <button className="filter-button apply-button" onClick={handleApplyFilters}>
                            <span>🔍</span> Apply
                        </button>
                        <button className="filter-button remove-button" onClick={handleRemoveFilters}>
                            <span>🗑️</span> Clear
                        </button>
                    </div>
                </div>
                <div className="domain-card-container">
                    {loading ? (
                        <div className="loading-spinner">
                            <svg className="animate-spin h-12 w-12 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    ) : domains.length > 0 ? (
                        domains.map((domain) => (
                            <Link to={`/${domain.name}${domain.tld}`} className="domain-card-link" key={domain._id}>
                                <div className="domain_card">
                                    <hr />
                                    <div className="domain-card-content">
                                        <div className="domain-name-price-div">
                                            <h3>{domain.name}{domain.tld}</h3>
                                            <div className="domain-price">
                                                <img
                                                    src={`https://flagcdn.com/16x12/${domain.countryCode}.png`}
                                                    alt={domain.currency}
                                                    style={{ width: '20px', height: '16px', marginRight: "5px" }}
                                                />
                                                {domain.price} <span style={{ fontSize: "14px", margin: "0" }}>{domain.currency}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))
                    ) : (
                        <p className="no-results">No domains found.</p>
                    )}
                </div>
                <div className="pagination">
                    <button
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1}
                    >
                        Previous
                    </button>
                    <span>
                        Page {page} of {pages}
                    </span>
                    <button
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page === pages}
                    >
                        Next
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default DomainListing;